import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
    eventLogHeader: {
        minWidth: '110px',
    },
});
